var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.1336 9.02686C15.0893 3.98259 6.9109 3.98259 1.86663 9.02686C1.63904 9.25444 1.42173 9.48841 1.21468 9.72817C0.977068 10.0033 0.858261 10.1409 0.808756 10.3248C0.767753 10.4771 0.774712 10.6674 0.826728 10.8163C0.889529 10.996 1.03099 11.1375 1.31391 11.4204L2.97402 13.0805C3.21194 13.3185 3.3309 13.4374 3.47204 13.5002C3.59671 13.5557 3.73309 13.5798 3.86922 13.5702C4.02333 13.5594 4.17578 13.4883 4.48068 13.346L7.05747 12.1435C7.41221 11.9779 7.58958 11.8952 7.70496 11.7637C7.8067 11.6478 7.87428 11.506 7.90019 11.3539C7.92956 11.1815 7.88209 10.9916 7.78714 10.6118L7.46455 9.32149C9.73317 8.46721 12.2665 8.46885 14.5356 9.32149L14.213 10.6118C14.1181 10.9916 14.0706 11.1815 14.1 11.3539C14.1259 11.506 14.1935 11.6478 14.2952 11.7637C14.4106 11.8952 14.588 11.9779 14.9427 12.1435L17.5195 13.346C17.8244 13.4883 17.9768 13.5594 18.131 13.5702C18.2671 13.5798 18.4035 13.5557 18.5281 13.5002C18.6693 13.4374 18.7882 13.3185 19.0262 13.0805L20.6863 11.4204C20.9692 11.1375 21.1106 10.996 21.1734 10.8163C21.2255 10.6674 21.2324 10.4771 21.1914 10.3248C21.1419 10.1409 21.0231 10.0033 20.7855 9.72817C20.5784 9.48841 20.3611 9.25444 20.1336 9.02686Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.4e293eea292a652eb7bbdd70b9967794.svg";
export { ForwardRef as ReactComponent };